module.exports = __webpack_public_path__ + "media/src/images/organisation_purchase-527dfaa3b8d7ee82f99ace4ff8d98f12.jpg";